<template>
  <AppRow class="mb-3">
    <AppColumn
      style="padding: 2px 10px!important; "
      :cols="5"
    >
      <v-autocomplete
        v-model="model.property"
        hide-details
        filled
        :items="items"
        :label="label"
        :item-text="$t"
        item-value="name"
      ></v-autocomplete>
    </AppColumn>

    <AppColumn
      style="padding: 2px"
      :cols="3"
    >
      <v-select
        v-model="model.descending"
        filled
        hide-details
        :items="Sorting.Order"
        label="ترتیب"
      >
      </v-select>
    </AppColumn>

    <AppColumn
      :cols="3"
      align-self="center"
    >
      <v-btn
        text
        color="error"
        @click="$emit('deleted')"
      >
        <AppIcon>mdi-delete</AppIcon>
        <span style="font-weight: bold"> حذف </span>
      </v-btn>
    </AppColumn>
  </AppRow>
</template>

<script>
import AppColumn from "@/components/library/container/AppColumn";
import AppRow from "@/components/library/container/AppRow";
import AppIcon from "@/components/library/common/AppIcon";
export default {
  name: "AppSortingSearch",
  components: { AppIcon, AppRow, AppColumn },
  props: ["model", "label", "items"],
  data: () => ({
    Sorting: {
      Order: [
        { text: "صعودی", value: false },
        { text: "نزولی", value: true },
      ],
    },
  }),
};
</script>
